const CustomerServiceIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14z'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
    />
    <path
      d='M8 10h5l3 3'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
      strokeLinecap='round'
    />
  </svg>
);
export default CustomerServiceIcon;
